import { getSystemLoci } from "../getSystemLoci";
export function cameraFocus(molstar, cellRefs) {
    if (cellRefs.length === 0)
        throw Error("Molstar: empty cellRef array");
    const lociArr = getSystemLoci(cellRefs[0], molstar);
    if (!lociArr)
        return;
    molstar.managers.camera.focusLoci(lociArr);
}
